import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-4eee8685"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "mx-auto wrapper"
};

const _hoisted_2 = /*#__PURE__*/_createTextVNode("注意事項");

const _hoisted_3 = {
  class: "text-white lh-lg text-start"
};
const _hoisted_4 = {
  class: "title-index text-end"
};

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, ". ", -1));

export default {
  __name: 'AlarmBlock',

  setup(__props) {
    const list = ['本網站為介紹元富證券推出 「2022 智富首選找元富線上開戶」(下稱：本活動) 中的贈品 NFT 介紹網頁，由資產管理公司 Bincentive Inc. 旗下 NFT服務品牌 InvestNFT 發行 (附上連結)。', '本活動共贈送 1,688 張 DemiNFT 作為優勝贈品，其贈品之圖像設計、NFT 享有之 Demily 賦能，由知名 NFT 團隊 DemiHuman 創作與提供，並持有著作權利。', '本活動贈送之 NFT 創建於以太鏈上，符合 ERC-721 規格之智能合約。', '本活動贈送之 NFT 享有內含虛擬通貨以太幣之價值，持有者若需於二級市場販售或贖回，需自行承擔贖回之一切額外費用 (例：鏈費，傳輸費用，交易手續費等等)', '本活動贈送之 NFT 領取資格與條件顯示於元富活動官網 (可以附上連結)，如在此頁面登記之元富會員應須先自身確認是否符合登記資格。', '本活動贈送之 NFT 其賦能將自活動結束後次月起算一年，超過一年後本活動將保有最終解釋權與變更或取消賦能之權利', '本活動贈送 NFT 之預設數位錢包為全球知名的 MetaMask 公司提供 (放上網站連結)，此錢包是用於與以太坊區塊鏈進行互動的軟體加密貨幣錢包。持有者需理解區塊鏈具有去中心化之獨特性，應妥善自行保管錢包之註記詞，私鑰，密碼與自身瀏覽器安全，若 NFT 遇遺失，被盜或其他第三方風險產生，將不在本活動負責範圍內。', '元富會員於本活動登記之身分證字號與錢包地址，登記前需詳讀使用條款，本活動僅提供元富證券做得獎者核對用，並不會用於其他用途。', '本活動中持有者所需創建的數位錢包MetaMask，虛擬通貨購買，交易所建立等，本活動僅提供客服與協助流程，並不會存取任一上述之帳號，密碼，私鑰等個人重要資訊。', '本活動贈送之 NFT 本身含有基礎價值與可流通性之價值，持用者需自行評估贈品之轉賣，贖回等價值的變動，本活動亦不保證預測即可實現。'];
    return (_ctx, _cache) => {
      const _component_landing_title = _resolveComponent("landing-title");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_landing_title, null, {
        default: _withCtx(() => [_hoisted_2]),
        _: 1
      }), _createElementVNode("div", _hoisted_3, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(list, (item, index) => {
        return _createElementVNode("div", {
          key: index,
          class: "d-flex lh-lg"
        }, [_createElementVNode("div", _hoisted_4, [_createElementVNode("span", null, _toDisplayString(index + 1), 1), _hoisted_5]), _createElementVNode("div", null, [_createElementVNode("span", null, _toDisplayString(item), 1)])]);
      }), 64))])]);
    };
  }

};